import React, { Component } from "react";

export class CompanyDetails extends Component {
  render() {
    return (
      <>
        <section className="usefulLinksContainer">
          <div className="links">
            <p style={{ color: 'white' }}>
              <span style={{ color: 'white', transition: 'font-weight 0.2s ease', display: 'inline-block', minWidth: '300px' }} onMouseOver={(e) => e.target.style.fontWeight = 'bold'} onMouseOut={(e) => e.target.style.fontWeight = 'normal'}>
                Company:- CIN: U64990GJ2025PTC164073
              </span>
              <span style={{ color: 'white', margin: '0 10px' }}>|</span>
              <span style={{ color: 'white', transition: 'font-weight 0.2s ease', display: 'inline-block', minWidth: '300px' }} onMouseOver={(e) => e.target.style.fontWeight = 'bold'} onMouseOut={(e) => e.target.style.fontWeight = 'normal'}>
                SEBI Regd No: INZ000331734 (Stock Broker)
              </span>
            </p>
            <p style={{ color: 'white' }}>
              <span style={{ color: 'white', transition: 'font-weight 0.2s ease', display: 'inline-block' }} onMouseOver={(e) => e.target.style.fontWeight = 'bold'} onMouseOut={(e) => e.target.style.fontWeight = 'normal'}>
                NSE ID :
              </span>
              <span style={{ color: 'white', margin: '0 10px' }}>|</span>
              <span style={{ color: 'white', transition: 'font-weight 0.2s ease', display: 'inline-block', minWidth: '150px' }} onMouseOver={(e) => e.target.style.fontWeight = 'bold'} onMouseOut={(e) => e.target.style.fontWeight = 'normal'}>
                BSE ID : 6975
              </span>
            </p>
          </div>
        </section>
      </>
    );
  }
}

export default CompanyDetails;
